<div class="row" *ngIf="show" oxAdobeDataNotifications>
  <div class="col-12">
    <!-- Gm Alert Message -->
    <div class="cit2-alert alert-{{type}} alert-dismissable d-flex flex-column {{margin}}"
          [class.bg-white]="whiteBackground">
      <div class="content">
        <div class="icon">
            <span aria-hidden="true" class="icon-{{icon}}"></span>
        </div>
        <div class="text">
          <div class="gb-body1" [class.heavy]="boldMessage">
            <ng-content></ng-content>
          </div>
        </div>
        <button *ngIf="dismissible" class="close" (click)="hideAlert()" aria-hidden="true" attr.aria-label="{{'aoda_close_modal_label' | translate}}">
          <span aria-hidden="true" class="icon-ui-closedot"></span>
        </button>
      </div>
      <!-- End Gm Alert Message -->
    </div>
  </div>
</div>
